export default {
  depositsPage: {
    title: "Цифровое депонирование",
    subtitle: "Публичный реестр записей о депонировании произведений и результатов интеллектуальной деятельности",
    applyFormCta: "Депонировать произведение",
    loadError: "Не удалось загрузить реестр. Попробуйте позже.",
    loadMoreError: "Не удалось подгрузить ещё записи.",
    empty: "Записей пока нет",
    searchLabel: "Поиск по реестру",
    searchPlaceholder: "Поиск по названию или номеру сертификата…",
    noTitle: "Без названия",
    statusUnknown: "Статус {{status}}",
    rowOpen: "Открыть запись: {{title}}",
    open: "Открыть",
    table: {
      title: "Название",
      status: "Статус",
      certificate: "Номер сертификата",
    },
    filters: {
      sortAria: "Сортировка",
      sortCertifiedNewest: "Сначала с более поздней датой сертификации",
      sortCertifiedOldest: "Сначала с более ранней датой сертификации",
      sortTitleAsc: "Название А–Я",
      sortTitleDesc: "Название Я–А",
      sortCertificateAsc: "Номер сертификата по возрастанию",
      sortWorkDateNewest: "Сначала более поздняя дата создания произведения",
      serverFiltersAria: "Дополнительные параметры отбора на сервере",
      workCategoryLabel: "Категория произведения",
      industryDirectionLabel: "Отраслевое направление",
      certifiedFrom: "Дата сертификации с",
      certifiedTo: "Дата сертификации по",
      optionAll: "Все",
    },
  },
  depositDetail: {
    back: "Назад",
    allDeposits: "К реестру",
    backToList: "Все записи реестра",
    loadError: "Не удалось загрузить запись. Попробуйте позже.",
    notFound: "Запись не найдена",
    status: "Статус",
    certificateNumber: "Номер сертификата",
    certifiedAt: "Дата сертификации",
    workCreationDate: "Дата создания произведения",
    creationCountryId: "Страна создания",
    workCategory: "Категория произведения",
    industryDirection: "Отраслевое направление",
    authorsTitle: "Авторы",
    rightsHoldersTitle: "Правообладатели",
    emptyList: "Нет данных",
    pseudonym: "псевдоним",
    sharePercent: "Доля: {{value}}%",
  },
  depositPage: {
    kicker: "Авторское право",
    title: "Депонирование произведений",
    subtitle:
      "Официальная регистрация и защита авторских прав на ваши произведения в фондах Российской государственной библиотеки.",
    step1Title: "Заполните форму",
    step1Desc: "Укажите данные о произведении и авторе",
    step2Title: "Загрузите файл",
    step2Desc: "Прикрепите электронную версию произведения",
    step3Title: "Получите свидетельство",
    step3Desc: "Документ о депонировании придёт на email",
    formTitle: "Подать заявку на депонирование",
    sentTitle: "Заявка отправлена!",
    sentHint: "Мы свяжемся с вами в течение 3 рабочих дней.",
    authorName: "Имя автора *",
    email: "Email *",
    workTitle: "Название произведения *",
    workType: "Тип произведения *",
    workTypePlaceholder: "Выберите тип",
    description: "Краткое описание *",
    year: "Год создания *",
    submit: "Отправить заявку",
    whatIsTitle: "Что такое депонирование?",
    whatIsText:
      "Депонирование — официальная передача рукописи на хранение в РГБ с фиксацией даты создания. Это подтверждает авторство и защищает ваши права.",
    formatsTitle: "Принимаемые форматы",
    helpTitle: "Нужна помощь?",
    helpText:
      "Наши специалисты готовы ответить на все вопросы о процедуре депонирования.",
    workTypes: {
      article: "Научная статья",
      monograph: "Монография",
      fiction: "Художественное произведение",
      dissertation: "Диссертация",
      textbook: "Учебное пособие",
      other: "Другое",
    },
    formats: {
      pdf: "PDF (предпочтительно)",
      docx: "DOCX / DOC",
      odt: "ODT",
      rtf: "RTF",
    },
  },
  depositsPortal: {
    pageTitle: "Кабинет депонирования",
    pageSubtitle: "Управляйте заявками, следите за модерацией и получайте свидетельства в одном месте.",
    kicker: "Кабинет",
    sidebarAria: "Разделы кабинета депонирования",
    sidebarTitle: "Депонирование",
    sidebarSubtitle: "Заявки и модерация",
    navAria: "Навигация по кабинету депонирования",
    navModerationSection: "Модерация",
    nav: {
      overview: "Обзор",
      my: "Мои депонирования",
      registry: "Публичный реестр",
      moderation: "Проверка заявок",
      newApplication: "Подать заявку",
    },
    overview: {
      title: "Обзор кабинета",
      subtitle: "Сводка по вашим заявкам и очереди модерации.",
      myHint: "Черновики, поданные заявки и выданные свидетельства",
      moderationHint: "Проверка заявок и выдача свидетельств",
      noSections: "Нет доступных разделов обзора для вашей учётной записи.",
      statsLoading: "Загружаем сводку…",
      statsLoadError: "Не удалось загрузить сводку. Попробуйте позже.",
      totalMy: "Всего: {{count}}",
      draftsCount: "Черновиков: {{count}}",
      byStatusTitle: "По статусам",
      moderationByTabTitle: "Фильтр по статусу очереди",
      moderationTotalRowLabel: "Всего",
      goToSection: "Перейти в раздел",
      retry: "Повторить запрос",
    },
    intro: {
      title: "Зафиксируйте авторство вашего проекта",
      subtitle: "Депонирование — это простой способ доказать, что вы создали работу первыми.",
      legalHint:
        "Депонирование — это регистрация вашего авторства на результат творческой деятельности на конкретный момент времени. Депонирование не является государственной регистрацией авторских прав, а фиксирует приоритет и служит доказательством авторства.",
      howTitle: "Как это работает",
      step1Title: "Загрузите проект",
      step1Desc: "Выберите готовый проект из портфолио или загрузите файл",
      step2Title: "Заполните данные",
      step2Desc: "Укажите автора, название, тип, дату создания",
      step3Title: "Получите свидетельство",
      step3Desc: "После модерации вы сможете скачать свидетельство о депонировании",
      startCta: "Начать депонирование",
      continueDraftCta: "Продолжить черновик",
      backToList: "К моим депонированиям",
      startError: "Не удалось создать заявку.",
    },
    my: {
      title: "Мои депонирования",
      subtitle: "Черновики, отправленные заявки и готовые свидетельства.",
      sectionSubtitle: "Поиск, статус и сортировка.",
      loadError: "Не удалось загрузить список. Попробуйте позже.",
      empty: "У вас пока нет заявок.",
      emptySearch: "Заявок с таким названием не найдено.",
      emptyCta: "Подать заявку на депонирование",
      continue: "Продолжить",
      deleteDraft: "Удалить черновик",
      confirmDeleteDraftTitle: "Удалить этот черновик?",
      confirmDeleteDraftMessage: "Действие нельзя отменить.",
      deleteError: "Не удалось удалить черновик.",
      openInRegistry: "В реестре",
      updated: "Обновлено",
      totalCount: "Всего записей: {{count}}",
      open: "Открыть",
      downloadCert: "Свидетельство",
      downloadCertLinkAria: "Перейти к свидетельству заявки «{{title}}»",
      tabsAria: "Фильтрация по статусу",
      tabs: {
        all: "Все",
        draft: "Черновики",
        moderation: "На модерации",
        confirmed: "Подтверждено",
        rejected: "Отклонено",
        revision: "Требуют правок",
      },
      filters: {
        search: "Поиск по названию",
        searchPlaceholder: "Название произведения…",
        statusAria: "Статус заявки",
        sortAria: "Сортировка списка",
        sortNewest: "Сначала новые",
        sortOldest: "Сначала старые",
        sortTitle: "По названию (А—Я)",
      },
      activeDraft: {
        title: "У вас есть активный черновик",
        noTitle: "Черновик без названия",
        continue: "Продолжить",
        discard: "Удалить",
      },
      revision: {
        banner_one: "У вас {{count}} заявка на доработке",
        banner_few: "У вас {{count}} заявки на доработке",
        banner_many: "У вас {{count}} заявок на доработке",
        banner_other: "У вас {{count}} заявок на доработке",
        showAll: "Показать все",
        continue: "Доработать",
        continueAria: "Продолжить доработку заявки «{{title}}»",
      },
    },
    myDetail: {
      back: "К моим депонированиям",
      loadError: "Не удалось загрузить запись. Попробуйте позже.",
      certDownloadError: "Не удалось скачать свидетельство.",
      originalDownloadError: "Не удалось скачать оригинал.",
      resumeError: "Не удалось открыть черновик для доработки.",
      downloadCert: "Скачать свидетельство",
      downloadOriginal: "Скачать оригинал",
      submittedAt: "Дата подачи",
      certifiedAt: "Дата сертификации",
      sections: {
        main: "Основная информация",
        file: "Файл произведения",
      },
      fileName: "Имя файла",
      fileSize: "Размер",
      fileType: "Тип",
      sha256: "SHA-256",
      revisionTitle: "Заявка возвращена на доработку",
      revisionEmpty: "Модератор не оставил комментарий.",
      resumeRevision: "Продолжить доработку",
      draftEditTitle: "Заявка в черновике",
      draftEditDescription:
        "Отредактируйте данные и снова отправьте заявку на модерацию — например, после отзыва с рассмотрения.",
      rejectedTitle: "Заявка отклонена",
      withdrawFromModeration: "Отозвать с модерации",
      withdrawFromModerationConfirm:
        "Отозвать заявку с модерации? Её можно будет снова подать после правок в черновике.",
      withdrawFromModerationError: "Не удалось отозвать заявку с модерации.",
      withdrawFromModerationAria: "Отозвать с модерации заявку «{{title}}»",
      deleteApplicationAria: "Удалить заявку «{{title}}»",
    },
    moderation: {
      title: "Модерация депонирования",
      subtitle: "Заявки, ожидающие решения. Фильтры и поиск по очереди.",
      loadError: "Не удалось загрузить очередь.",
      forbidden403:
        "Доступ запрещён: заявка вне вашей зоны модерации по отраслевому направлению или недостаточно прав. Если это ошибка — обратитесь к администратору.",
      empty: "Нет заявок по выбранным условиям.",
      totalCount: "Всего: {{count}}",
      approve: "Одобрить",
      reject: "Отклонить",
      approveError: "Не удалось одобрить заявку.",
      rejectError: "Не удалось отклонить заявку.",
      rejectTitle: "Причина отклонения",
      rejectReason: "Комментарий для заявителя",
      cancel: "Отмена",
      rejectConfirm: "Отклонить",
      openDetail: "Открыть",
      openDetailAria: "Открыть заявку «{{title}}» для модерации",
      approveAria: "Одобрить заявку «{{title}}»",
      rejectAria: "Отклонить заявку «{{title}}»",
      primaryAuthor: "Автор",
      listIndustryDirection: "Отраслевое направление:",
      listWorkCategory: "Категория произведения:",
      tabs: {
        all: "Все",
        pending: "В очереди",
        confirmed: "Подтверждено",
        revision: "На доработке",
        rejected: "Отклонено",
      },
      filters: {
        title: "Название",
        titlePlaceholder: "Название произведения…",
        certificateOrId: "Номер / ID",
        certificateOrIdPlaceholder: "Сертификат или UUID…",
        author: "ФИО автора",
        authorPlaceholder: "Иванов Иван…",
        rightsHolder: "Правообладатель",
        rightsHolderPlaceholder: "ФИО, организация, контакт, ИНН, ОГРН…",
        from: "Подано с",
        to: "Подано по",
        status: "Статус очереди",
        datePlaceholder: "Выберите дату",
        calendarFromAria: "Календарь: дата подачи с",
        calendarToAria: "Календарь: дата подачи по",
        statusFilterAria: "Фильтр очереди по статусу",
      },
    },
    moderationDetail: {
      back: "К очереди модерации",
      loadError: "Не удалось загрузить заявку.",
      revisionError: "Не удалось отправить заявку на доработку.",
      downloadOriginal: "Скачать оригинал",
      sendForRevision: "На доработку",
      revisionTitle: "Вернуть заявителю на доработку",
      revisionComment: "Комментарий для заявителя",
      revisionSend: "Отправить",
      confirmApprove: "Одобрить заявку и выдать сертификат?",
      sections: {
        main: "Основная информация",
      },
      creationCity: "Город создания",
      applicant: "Заявитель",
      applicantId: "ID пользователя",
      primaryAuthor: "Первичный автор",
      consentPersonalData: "Согласие на обработку персональных данных",
      consentDepositRules: "Согласие с правилами депонирования",
      consentUserTerms: "Согласие с пользовательским соглашением",
      legalDocumentsVersion: "Версия правовых документов",
      applicantHint: "Полный профиль заявителя недоступен: отображаются данные из заявки.",
      statusHistory: "История статусов",
      moderationActions: "Действия модерации",
      contactPerson: "Контактное лицо",
      linkedUserId: "Связанный пользователь",
      authorRole: {
        author: "Автор",
        coAuthor: "Соавтор",
      },
    },
    wizard: {
      title: "Заявка на депонирование",
      subtitle: "Заполните шаги и отправьте заявку на рассмотрение.",
      preparing: "Создаём черновик…",
      createError: "Не удалось создать заявку.",
      loadError: "Не удалось загрузить заявку.",
      saveError: "Не удалось сохранить.",
      submitError: "Не удалось отправить заявку.",
      uploadError: "Не удалось загрузить файл.",
      notDraftHint: "Эта заявка уже отправлена или недоступна для редактирования.",
      backToList: "К списку депонирований",
      stepsAria: "Шаги заявки",
      stepLabel: {
        1: "Файл",
        2: "Авторы и правообладатели",
        3: "Произведение",
      },
      stepHeading: {
        1: "Загрузите файл произведения",
        2: "Сведения о произведении",
        3: "Авторы",
        4: "Правообладатели",
      },
      stepFile: {
        title: "Файл произведения",
        hint: "Загрузите готовый файл. Мы зафиксируем его хэш (sha256) как доказательство целостности.",
        maxSizeWarning: "Максимальный размер файла — 150 МБ.",
        fileTooLarge: "Файл больше 150 МБ. Выберите файл меньшего размера.",
        dropZoneTitle: "Нажмите, чтобы выбрать файл",
        dropZoneSubtitle:
          "Принимаются PDF; изображения JPEG, PNG и JFIF; видео MP4, MOV, AVI, MKV и WebM; аудио MP3, WAV, OGG, FLAC, AAC, M4A, M4B, M4P и M4V.",
        uploading: "Загружаем файл…",
        unnamedFile: "Файл",
        replace: "Заменить файл",
        clear: "Удалить файл",
      },
      consents: {
        title: "Я подтверждаю",
        personalData: "Согласие на обработку персональных данных.",
        depositRules: "Правила и порядок депонирования.",
        userTerms: "Пользовательское соглашение и политику конфиденциальности.",
        link: "Открыть документ",
      },
      fields: {
        title: "Название произведения",
        description: "Описание",
        workCategory: "Категория произведения",
        industryDirection: "Отраслевое направление",
        workCreationDate: "Дата создания произведения",
        country: "Страна создания",
        authorName: "ФИО автора",
        authorLastName: "Фамилия",
        authorFirstName: "Имя",
        authorPatronymic: "Отчество",
        authorRole: "Роль",
        pseudonym: "Псевдоним",
        authorCountry: "Страна автора",
        holderKind: "Тип правообладателя",
        holderName: "ФИО",
        orgName: "Наименование организации",
        sharePercent: "Доля, %",
        holderInn: "ИНН",
        holderOgrn: "ОГРН",
        holderContactPerson: "Контактное лицо",
        holderCountry: "Страна правообладателя",
      },
      placeholders: {
        select: "Выберите…",
        country: "Страна…",
        date: "Выберите дату…",
      },
      hints: {
        shareTotal:
          "Сумма долей всех правообладателей — 100%. При изменении доли одного остальные пересчитываются автоматически (пропорционально их прежним долям).",
        shareClamped: "Доля не может быть больше 100%.",
        titleMaxLength: "255 символов — максимальная длина названия.",
      },
      addAuthor: "Добавить автора",
      addRightsHolder: "Добавить правообладателя",
      removeRow: "Удалить",
      back: "Назад",
      next: "Далее",
      exit: "Выйти в список",
      submit: "Отправить на модерацию",
      footerTooltips: {
        exit:
          "Закрыть мастер и вернуться к списку заявок. Прогресс сохраняется в черновике при переходе между шагами.",
        back: "Вернуться к предыдущему шагу без отправки заявки.",
        next: "Проверить заполнение шага, сохранить и перейти к следующему.",
        nextBusy: "Сохраняем шаг, подождите…",
        submit: "Отправить заполненную заявку на модерацию.",
        submitBusy: "Отправляем заявку, подождите…",
      },
      validation: {
        file: "Загрузите файл произведения.",
        title: "Укажите название произведения.",
        workCategory: "Выберите категорию произведения.",
        industryDirection: "Выберите отраслевое направление.",
        workCreationDate: "Укажите дату создания произведения.",
        creationCountry: "Выберите страну создания.",
        author: "Для каждого автора укажите фамилию и имя.",
        rightsHolder:
          "По каждому правообладателю заполните обязательные поля: для физлица — страна и ФИО; для организации — страна, наименование, ИНН, ОГРН, контактное лицо.",
        consents: "Подтвердите все три согласия.",
      },
    },
  },
  depositDrafts: {
    title: "Черновики",
    subtitle: "Черновики сохраняются при оформлении заявки. Продолжайте заполнение или удалите ненужное.",
    loginPrompt: "Войдите в аккаунт, чтобы видеть и создавать черновики заявки на депонирование.",
    loginCta: "Войти",
    newDraft: "Новый черновик",
    creating: "Создание…",
    loadError: "Не удалось загрузить черновики. Попробуйте позже.",
    createError: "Не удалось создать черновик. Попробуйте позже.",
    detailLoadError: "Не удалось загрузить черновик.",
    empty: "Черновиков пока нет.",
    totalCount: "Всего черновиков: {{count}}",
    tableAria: "Список черновиков заявки на депонирование",
    colTitle: "Название",
    colStep: "Шаг",
    colCreated: "Создан",
    colFlags: "Данные",
    colActions: "Действия",
    flagPortfolio: "Портфолио",
    flagFile: "Файл",
    openDraft: "Открыть черновик: {{title}}",
    continueDraft: "Продолжить оформление: {{title}}",
    deleteDraft: "Удалить черновик: {{title}}",
    modalTitle: "Черновик",
    modalClose: "Закрыть",
    modalStep: "Текущий шаг",
    modalWorkTitle: "Название произведения",
    modalDescription: "Описание",
    modalWorkDate: "Дата создания произведения",
    modalId: "Идентификатор",
    cabinetDraftHint: "Заявка в подготовке или после отзыва с модерации — продолжите в мастере.",
    cabinetNoDeleteHint:
      "Кнопка «Удалить» удаляет только черновики из верхнего списка. Заявки из кабинета (в т.ч. после отзыва с модерации) этим действием не удаляются — в API нет операции удаления записи заявки.",
    continueCabinetRecord: "Продолжить в мастере",
    openCabinetRecord: "Карточка заявки",
  },
}
